/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bench_SavedInputs */

const en_fw_bench_saved = /** @type {(inputs: Fw_Bench_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark preference saved.`)
};

const id_fw_bench_saved = /** @type {(inputs: Fw_Bench_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferensi benchmark tersimpan.`)
};

/**
* | output |
* | --- |
* | "Benchmark preference saved." |
*
* @param {Fw_Bench_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bench_saved = /** @type {((inputs?: Fw_Bench_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bench_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bench_saved(inputs)
	return en_fw_bench_saved(inputs)
});